export const generateId = (length = 7) => 'm' + (Math.random() + 1).toString(36).substring(length);
